import Editor from ".";
import EventEmitter from "./eventEmitter";
import { toolbar } from "../utils/editorLayoutElems";
import { HE, IToolbar } from "../types";
import { $createEl } from "../utils/domHelpers";

class ToolbarManager {
  private toolbars: IToolbar[] = [];

  constructor(
    private containerElem: HTMLElement,
    private ee: EventEmitter,
    private editor: Editor
  ) {}

  init() {
    this.toolbars = this.editor.getConfig().toolbars || [];
    this.loadToolbar();
  }

  loadToolbar() {
    if (this.toolbars.length === 0) return;

    this.toolbars.forEach(({ name, icon, click }) => {
      const option = $createEl(
        "div",
        icon,
        {
          title: name,
        },
        {
          click: () => click(this.editor),
        }
      );

      toolbar.append(option);
    });

    const frame = this.editor.getFrame();

    (frame as any).contentWindow?.document.body?.append(toolbar);

    (frame as HTMLIFrameElement).contentWindow?.window.addEventListener(
      "resize",
      this.show
    );
  }

  show = () => {
    const selectedEl = this.editor.getSelectedEl();

    if (!selectedEl || selectedEl?.id === "page") {
      this.hide();
      return;
    }

    this.containerElem.style.display = "block";

    const frame = this.editor.getFrame() as HTMLIFrameElement;
    const window = frame?.contentWindow?.window;
    const toolbar = this.containerElem;
    const elementRect = (selectedEl as HE).getBoundingClientRect();
    const isElementAtTop = elementRect.top < (window as any).innerHeight / 2;

    if (toolbar) {
      if (isElementAtTop) {
        toolbar.style.top = elementRect.bottom + "px";
        toolbar.classList.remove("top");
      } else {
        toolbar.style.top = elementRect.top - toolbar.clientHeight + "px";
        toolbar?.classList.add("top");
      }

      toolbar.style.display = "flex";
      toolbar.style.right =
        (window as any).innerWidth - elementRect.right + "px";
    }
  };

  hide = () => {
    this.containerElem.style.display = "none";
  };
}

export default ToolbarManager;
